import {
    Button, Grid, InputAdornment, Paper
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import SearchIcon from '@material-ui/icons/Search';
import classNames from 'classnames';
import { debounce } from 'lodash';
import MUIDataTable from "mui-datatables";
import queryString from "query-string";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { Waypoint } from "react-waypoint";
import EmptyStateImg from "../../../assets/diesel-card-empty-state.png";
import * as logger from "../../../logger";
import { defaultDebounceMs, defaultPageNo, defaultPageSize } from '../../../paginationVariables';
import { fetchFuelCardList, getCashbackStepper } from "../../../store/actions/vehicleActionCreator";
import * as constants from "../../../store/constants";
import { dieselCardTableHeight } from "../../../styleVariables";
import { numberFormat } from "../../../utils/utils";
import Banner from "../../components/DieselCardComponents/Banner";
import DriverDetailsDialog from "../../components/DieselCardComponents/DriverDetailsDialog";
import FuelPumpSearch from "../../components/DieselCardComponents/FuelBunkFinder";
import DieselCardEducation from "../../components/RightSideBar/DieselCardEducation";
import CashbackStepperDialog from "../../components/RightSideBar/DieselCardSideBar/CashbackStepper";
import DieselCardRechargeSideBar from "../../components/RightSideBar/DieselCardSideBar/RechargeSideBar";
import AddVehicle from "../Vehicles/AddVehicle";
import { DieselCardCss as useStyles } from "./DieselCardCss";

const DieselCard = ({ user, vehicle, dispatchFetchFuelCardList, dispatchGetWalletBalance, dispatchGetCashbackStepper }) => {

    let history = useHistory();
    let search = window.location.search;
    const params = queryString.parse(search);
    let orderId = params["order_id"];
    const queryParams = new URLSearchParams(window.location.search)

    const [dieselCardConfig, setDieselCardConfig] = useState({});
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [addVehicleOpen, toggleAddVehicleOpen] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [dieselCardData, setDieselCardData] = useState({ trucks: [] })
    const [loadingText, setLoadingText] = useState("Sorry, no Trucks found");
    const [currentPageNo, setCurrentPageNo] = useState(defaultPageNo);
    const [currentPageSize, setCurrentPageSize] = useState(defaultPageSize);
    const [truckDetails, setTruckDetails] = useState({});
    const [driverDetailsOpen, setDriverDetailsOpen] = useState(false);
    const [rechargeSideBarOpen, setRechargeSideBarOpen] = useState(false);
    const [cashbackStepperOpen, setCashbackStepperOpen] = useState(false);
    const [cashbackStepperInfo, setCashbackStepperInfo] = useState({});

    const checkEducationalSideBar = localStorage.getItem("dieselCardEducationalSideBar");

    const dieselCardReqData = {
        pageNo: defaultPageNo,
        pageSize: defaultPageSize,
        searchText: searchText
    };

    useEffect(() => {

        const d = new Date();
        let month = d.getMonth();
        let year = d.getFullYear();
        const currentMonth = constants.MONTHS[month]

        setLoadingText("Loading........");

        vehicle.dieselCardList = {}

        dispatchFetchFuelCardList(dieselCardReqData,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    setLoadingText("Sorry, no Trucks found");
                    logger.log("Diesel Card Dweb", "Fetch Fuel Card List Successfull");

                    const requestData = {
                        monthYear: currentMonth + "-" + year
                    }

                    dispatchGetCashbackStepper(requestData,
                        (data) => {
                            if (data && data.status && data.status.code == 200) {
                                logger.log("Cashback Stepper Diesel Card Dweb", "Get cashback stepper successful");
                                setCashbackStepperInfo(data.response);

                                if (orderId) {
                                    if (queryParams.has('order_id')) {
                                        queryParams.delete('order_id')
                                        history.replace({
                                            search: queryParams.toString(),
                                        })
                                    }
                                }

                            }
                        },
                        () => {
                            logger.log("Cashback Stepper Diesel Card Dweb", "Get cashback stepper failed");
                        }
                    )
                }
            },
            () => {
                logger.log("Diesel Card Dweb", "Fetch Fuel Card List Failed");
                setLoadingText("Sorry, no Trucks found");
            }
        )

    }, []);

    useEffect(() => {

        if (vehicle.dieselCardList) {
            setDieselCardData(vehicle.dieselCardList)
        }

    }, [vehicle.dieselCardList]);

    useEffect(() => {

        if (user && user.fuelCardConfig) {
            setDieselCardConfig(user.fuelCardConfig)
        }

    }, [user.fuelCardConfig]);

    useEffect(() => {

        const parentElement = document.getElementById("transaction-table");
        if (parentElement) {
            if (document.getElementById("transaction-table").firstChild) {
                document.getElementById("transaction-table").firstChild.style.height = "100%";
                document.getElementById("transaction-table").firstChild.style.boxShadow = "none";

                if (document.getElementById("transaction-table").firstChild.children[2]) {
                    document.getElementById("transaction-table").firstChild.children[2].style.minHeight = "82%";
                }

            }
        }

    }, [dieselCardData])

    // ***************************** Assigning css classes *****************************
    const classes = useStyles()

    // ********************* Education screen functionality **********************
    const handleEducationClose = () => {
        setSidebarOpen(false);
        localStorage.setItem("dieselCardEducationalSideBar", "shown")
    }

    // ************************** Add truck functionality **************************
    const handleAddVehicleOpen = () => {
        toggleAddVehicleOpen(true);
    };

    const handleAddVehicleClose = () => {
        toggleAddVehicleOpen(false);
    };

    const handleAddVehicleSave = () => {
        toggleAddVehicleOpen(false);
        handleFuelCardListRecall();
    }

    // ******************************** Table Config ********************************
    const onSearchBlur = debounce(query => {
        dieselCardData.trucks = [];
        setLoadingText("Loading........");
        setCurrentPageNo(defaultPageNo);
        dispatchFetchFuelCardList({ ...dieselCardReqData, searchText: query },
            () => {
                setLoadingText("Sorry, no Trucks found");
            },
            () => {
                setLoadingText("Sorry, no Trucks found");
            }
        )
    }, user && user.configs && user.configs.dwebSearchBebounceMs ? parseInt(user.configs.dwebSearchBebounceMs) : defaultDebounceMs);

    const muiColumns = [
        {
            name: 'vehicleNumber',
            label: "Truck No.",
            options: {
                filter: false,
                sort: false,
                searchable: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    let data = muiData[dataIndex];

                    if (rowIndex === muiData.length - 3) {
                        return (
                            <>
                                <Waypoint
                                    onEnter={() => {
                                        if (currentPageNo < dieselCardData.maxpageCount) {
                                            getPaginatedData()
                                            setCurrentPageNo(currentPageNo + 1)
                                        }
                                    }}
                                />
                                <div style={{ display: 'flex', textTransform: 'uppercase', fontWeight: 'bold' }}>
                                    {data && data.vehicleNumArrayValue && data.vehicleNumArrayValue.length > 2 && data.vehicleNumArrayValue.map((item, index) => (
                                        <div className={index != 0 ? classes.mlV1 : ""}><span className={data && index == data.vehicleNumArrayValue.length - 1 ? data.status.toLowerCase() == "new" ? classes.blueColor : classes.orangeColor : ""}>{item}</span></div>
                                    ))}
                                    {data && data.ownershipType.toLowerCase() == "hired" ?
                                        <div className={classes.marketLabel}>Market</div>
                                        :
                                        <div className={classes.ownLabel}>Own</div>
                                    }
                                </div>
                            </>
                        );
                    } else {
                        return (
                            <>
                                <div style={{ display: 'flex', textTransform: 'uppercase', fontWeight: 'bold' }}>
                                    {data && data.vehicleNumArrayValue && data.vehicleNumArrayValue.length > 2 && data.vehicleNumArrayValue.map((item, index) => (
                                        <div className={index != 0 ? classes.mlV1 : ""}><span className={data && index == data.vehicleNumArrayValue.length - 1 ? data.status.toLowerCase() == "new" ? classes.blueColor : classes.orangeColor : ""}>{item}</span></div>
                                    ))}
                                    {data && data.ownershipType.toLowerCase() == "hired" ?
                                        <div className={classes.marketLabel}>Market</div>
                                        :
                                        <div className={classes.ownLabel}>Own</div>
                                    }
                                </div>
                            </>
                        )
                    }
                }
            }
        },
        {
            name: "vehicleId",
            label: 'Driver Details',
            options: {
                filter: false,
                sort: false,
                searchable: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    let data = muiData[dataIndex];

                    if (data && data.driverId) {
                        return (
                            <div className={classes.divAlign}>
                                <div>{data.driverName}</div>
                                {data.driverNumber &&
                                    <>
                                        <FiberManualRecordIcon className={classes.circle} />
                                        <div>{data.driverNumber}</div>
                                    </>
                                }
                            </div>
                        )
                    } else {
                        return (
                            <div>--</div>
                        )
                    }

                }
            }
        },
        {
            name: "balance",
            label: "Balance",
            options: {
                filter: false,
                sort: false,
                searchable: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    let data = muiData[dataIndex];

                    if (data && data.balance == "None") {
                        return (
                            <div>--</div>
                        )
                    } else {
                        return (
                            <div>{numberFormat(data.balance)}</div>
                        )
                    }
                }
            }
        },
        {
            name: "vehicleId",
            label: "Action",
            options: {
                filter: false,
                sort: false,
                searchable: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    let data = muiData[dataIndex];

                    if (data && data.status.toLowerCase() == "new") {
                        return (
                            <div>
                                <Button variant="outlined" className={classes.activateButton} onClick={() => handleActivateClick(data)}>Activate</Button>
                            </div>
                        )
                    } else {
                        return (
                            <div>
                                {/* <Button variant="contained" className={classes.rechargeButton} onClick={() => handleRechargeClick(data)}>Recharge</Button> */}
                            </div>
                        )
                    }
                }
            }
        }
    ]

    const muiData = dieselCardData && dieselCardData.trucks ? dieselCardData.trucks : [];
    const options = {
        rowsPerPage: 100,
        rowsPerPageOptions: [10, 100, 250],
        filterType: "multiselect",
        fixedHeader: true,
        tableBodyHeight: dieselCardTableHeight,
        selectableRows: 'none',
        searchOpen: true,
        search: false,
        jumpToPage: false,
        download: false,
        filter: false,
        print: false,
        viewColumns: false,
        pagination: false,
        customToolbar: (data) => {
            return <>
                <div className={classes.divFilter}>
                    <div>
                        <Button variant="contained" className={classes.addTruckButton} onClick={handleAddVehicleOpen} startIcon={<AddIcon />}>Add Truck</Button>
                    </div>
                </div>
            </>
        },
        customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {

        },
        onRowClick: (rowData, rowMeta) => {
        },
        onCellClick: (colData, cellMeta) => {

            const seletedRow = muiData && muiData[cellMeta && cellMeta.dataIndex ? cellMeta.dataIndex : 0] ? muiData[cellMeta && cellMeta.dataIndex ? cellMeta.dataIndex : 0] : {}

            if (cellMeta.colIndex != 3) {
                goToSingleDieselCard(seletedRow);
            }

        },
        searchProps: {
            variant: "outlined",
            // value: searchText,
            InputProps: {
                startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
            },
            onBlur: (e) => {
            },
            onKeyUp: (e) => {
            },
            onKeyDown: (event) => {
                if (event.keyCode === 27) {
                }
            }
        },
        searchPlaceholder: 'Search Truck Number',
        onSearchChange: (val) => {
            let value = val ? !val.replace(/\s/g, '').length ? val.trim() : val : "";
            setSearchText(value);
            if (value && value.length > 1) {
                onSearchBlur(value)
            } else if (searchText && value && value.trim().length <= 1) {
                setSearchText("");
                onSearchBlur("")
            } else {
                setSearchText("");
                onSearchBlur("")
            }
        },
        onSearchClose: () => {
        },
        customSearch: (searchQuery, currentRow, columns) => {
            let isFound = false;
            return true;
        },
        textLabels: {
            body: {
                noMatch: loadingText,
                toolTip: "Sort",
                columnHeaderTooltip: column => `Sort for ${column.label}`
            }
        }
    };

    const getPaginatedData = () => {
        const dieselCardReqData = {
            pageNo: currentPageNo + 1,
            pageSize: currentPageSize,
            searchText: searchText,
            merge: true
        };

        dispatchFetchFuelCardList(dieselCardReqData,
            () => {
            },
            () => {
            }
        )
    }

    const handleActivateClick = (truckInfo) => {
        setTruckDetails(truckInfo);
        setDriverDetailsOpen(true);
    }

    const handleDriverDetailsClose = () => {
        setDriverDetailsOpen(false);
        handleFuelCardListRecall();
    }

    const handleRechargeClick = (truckData) => {
        setRechargeSideBarOpen(true);
        setTruckDetails(truckData);
    }

    const handleRechargeSideBarClose = () => {
        setRechargeSideBarOpen(false);
        handleFuelCardListRecall();
    }

    const handleFuelCardListRecall = () => {
        dispatchFetchFuelCardList(dieselCardReqData,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    setLoadingText("Sorry, no Trucks found");
                    logger.log("Diesel Card Dweb", "Fetch Fuel Card List Successfull");
                }
            },
            () => {
                logger.log("Diesel Card Dweb", "Fetch Fuel Card List Failed");
                setLoadingText("Sorry, no Trucks found");
            }
        )
    }

    const goToSingleDieselCard = (truckInfo) => {
        if (truckInfo && truckInfo.status && truckInfo.status.toLowerCase() != "new") {
            history.push({
                pathname: `/diesel-card/single-diesel-card/${truckInfo && truckInfo.vehicleId ? truckInfo.vehicleId : ""}/${truckInfo && truckInfo.fuelBrokerId ? truckInfo.fuelBrokerId : ""}`,
                state: {
                    id: 1,
                    pageTitle: "Diesel Card",
                    vehicleNumber: truckInfo && truckInfo.vehicleNumArrayValue ? truckInfo.vehicleNumArrayValue : []
                }
            })
        }
    }

    const handleCashbackStepper = () => {
        setCashbackStepperOpen(true);
    }

    const handleCashbackStepperClose = () => {
        setCashbackStepperOpen(false);
    }


    return (
        <>
            {!checkEducationalSideBar &&
                <DieselCardEducation rightSideBarOpen={sidebarOpen} onClose={handleEducationClose} />
            }

            <Grid container className={classes.gridContainerV1} wrap="nowrap" >
                <Grid container direction="column" wrap="nowrap">
                    {/* <Grid item>
                        <Banner />
                    </Grid> */}

                    <Grid item className={classes.mt8} style={{ height: '100%' }}>
                        {
                            <>
                                {dieselCardData && !dieselCardData.userhasActiveTruck ?
                                    (
                                        <Paper className={classes.paperEmptyState}>
                                            <div className={classes.divEmptyState}>
                                                <img src={EmptyStateImg} />
                                                <div className={classes.textV1}>{dieselCardConfig && dieselCardConfig.listing_page_text ? dieselCardConfig.listing_page_text : ""}</div>
                                                <div><Button variant="contained" className={classes.addTruckButton} onClick={handleAddVehicleOpen}>Add Truck</Button></div>
                                            </div>
                                        </Paper>
                                    )
                                    :
                                    (
                                        <Paper className={classes.paperV1} id="transaction-table">
                                            <MUIDataTable title={""} data={muiData} columns={muiColumns} options={options} />
                                        </Paper>
                                    )
                                }
                            </>
                        }
                    </Grid>
                </Grid>

                <Grid container direction="column" wrap="nowrap" className={classes.gridContainerV2}>

                    {/* <Grid item>
                        <Paper className={classes.paperRecharge} onClick={() => handleCashbackStepper()}>
                            <div className={classNames(classes.divAlignV1, classes.divContainer)}>
                                <div>
                                    <div className={classes.titleV1}>Month's Recharges </div>
                                    <div className={cashbackStepperInfo.rechargeAmount == 0 ? classes.rechargeAmount : classes.rechargeProfit}>{numberFormat(cashbackStepperInfo && cashbackStepperInfo.rechargeAmount ? cashbackStepperInfo.rechargeAmount : 0)}</div>
                                </div>
                                <div>
                                    <div className={classNames(classes.titleV1, classes.textAlignRight)}>Cashback Earned</div>
                                    <div className={classes.cashbackAmountText}>{numberFormat(cashbackStepperInfo && cashbackStepperInfo.cashbackAmount ? cashbackStepperInfo.cashbackAmount : 0)}&nbsp;{cashbackStepperInfo && cashbackStepperInfo.cashbackAmount ? `(${cashbackStepperInfo && cashbackStepperInfo.cashbackPercentage ? cashbackStepperInfo.cashbackPercentage : ""})` : ""}</div>
                                </div>
                            </div>
                            <div className={classNames(classes.divFooterV1, classes.divAlignV1)}>
                                <div>{dieselCardConfig && dieselCardConfig.listing_page_text ? dieselCardConfig.listing_page_text : ""}</div>
                                <ChevronRightIcon />
                            </div>
                        </Paper>
                    </Grid> */}

                    {dieselCardConfig && dieselCardConfig.redirect_to_fuel_pump_finder &&
                        <Grid item>
                            <FuelPumpSearch />
                        </Grid>
                    }
                </Grid>

            </Grid>

            {/* **************************** Add Vehicle Component **************************** */}
            {addVehicleOpen && <AddVehicle open={addVehicleOpen} onClose={handleAddVehicleClose} onSave={handleAddVehicleSave} />}

            {/* **************************** Select Driver Component. **************************** */}
            {driverDetailsOpen && <DriverDetailsDialog open={driverDetailsOpen} onClose={handleDriverDetailsClose} truckInfo={truckDetails} />}

            {/* **************************** Recharge sidebar **************************** */}
            {rechargeSideBarOpen && <DieselCardRechargeSideBar rightSideBarOpen={rechargeSideBarOpen} onClose={handleRechargeSideBarClose} truckInfo={truckDetails} fromFlow={"dieselCard"} />}

            {/* **************************** Cashback Sidebar **************************** */}
            {cashbackStepperOpen && <CashbackStepperDialog open={cashbackStepperOpen} onClose={handleCashbackStepperClose} />}

        </>
    )
}

const mapStateToProps = (state) => (state)
const mapDispatchToProps = (dispatch) => ({
    dispatchFetchFuelCardList: (requestData, onSuccess, onError) => {
        dispatch(fetchFuelCardList(requestData, onSuccess, onError))
    },
    dispatchGetCashbackStepper: (data, onSuccess, onError) => {
        dispatch(getCashbackStepper(data, onSuccess, onError))
    },
})
export default connect(mapStateToProps, mapDispatchToProps)(DieselCard)
